import React, { useState } from "react";
import TestimonialCard from "./TestimonialCard";
import { testimonials } from "../data/testimonialsData";

export default function TestimonialsSection({ limit, empty = null }) {
  const [showAll, setShowAll] = useState(false);

  const displayed =
    limit && !showAll ? testimonials.slice(0, limit) : testimonials;

  // No reviews, no section. An empty "What Our Explorers Say" heading with
  // nothing under it is worse than not asking the question — and the page that
  // is ABOUT reviews passes its own message in rather than showing a blank.
  if (!testimonials.length) return empty;

  return (
    <section className="section-y bg-primary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-primary-50 text-primary-700 text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Traveler Stories
          </span>
          <h2 className="section-title">What Our Explorers Say</h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            What people say after travelling Gilgit-Baltistan with us.
          </p>
        </div>

        {/* Overall rating: computed from the reviews actually published.
            This used to be a hardcoded "4.9 out of 5 — based on 12,000+
            verified reviews", which was true of no data anywhere in the site. */}
        {(() => {
          const rated = testimonials.filter((t) => typeof t.rating === "number");
          if (!rated.length) return null;
          const avg = rated.reduce((a, t) => a + t.rating, 0) / rated.length;
          return (
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
              <div className="flex items-center gap-2">
                {Array.from({ length: 5 }, (_, i) => (
                  <svg
                    key={i}
                    className={`w-6 h-6 fill-current ${i < Math.round(avg) ? "text-yellow-400" : "text-gray-300"}`}
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
              <p className="text-gray-700 font-semibold">
                {avg.toFixed(1)} out of 5 —{" "}
                <span className="text-gray-500 font-normal">
                  from {rated.length} review{rated.length === 1 ? "" : "s"}
                </span>
              </p>
            </div>
          );
        })()}

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayed.map((testimonial) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </div>

        {/* Show more / less toggle (only when limit is set) */}
        {limit && testimonials.length > limit && (
          <div className="text-center mt-12">
            <button
              onClick={() => setShowAll((prev) => !prev)}
              className="btn-outline"
            >
              {showAll ? "Show Less" : `Read More Reviews (${testimonials.length - limit} more)`}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
